import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppWideUser, Token } from "../Services/AppUserProfile";
import { UserService } from "../Services/user.service";

@Component({
  selector: 'app-terms-condition',
  templateUrl: './terms-condition.component.html',
  styleUrls: ['./terms-condition.component.scss'],
  providers: [UserService]
})
export class TermsConditionComponent implements OnInit {
  public loading = false;

  constructor(private router: Router, private userService: UserService, private token: Token, private appUser: AppWideUser) { }

  ngOnInit() {
  }

  OnActionTaken(inputString: string) {

    if (inputString == "agree") {
      this.loading = true;
      this.userService.FirstTimeUserLogged(this.appUser.UserId, this.token).subscribe(x => {
        this.loading = false;
        this.router.navigate(["layout"]);
      },
        error => {
          this.loading = false;
        })
    }
    else if (inputString == "disagree") {
      this.router.navigate(["login"]);
    }
  }

}



// WEBPACK FOOTER //
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/terms-condition/terms-condition.component.ts